module.exports = __webpack_public_path__ + "static/img/ThuongTin.e043c74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ThuongTin.png
// module id = u+xk
// module chunks = 1